/*eslint-disable */
define(["jquery"], function($) {
    var MILLISECONDS = 1;

    var windowClass = "modal-window";
    var delayBeforeShowing = 200 * MILLISECONDS
    var overlayDelayId;

    function showModal(showOverlay, text, noDefer) {
        if ($("body").hasClass("initial-load")) {
            return;
        }

        hideModal();

        if (noDefer) {
            show();
        } else {
            // Showing is deferred for a short while, to avoid showing it for
            // requests that complete very quickly.
            overlayDelayId = setTimeout(show, delayBeforeShowing);
        }

        function show() {
            if (showOverlay) {
                var modalWindow = $("<div></div>");

                modalWindow.addClass(windowClass);
                modalWindow.css("height", $(document).height() + "px");
                modalWindow.css("width", $(document).width() + "px");
                $("body").append(modalWindow);

                $(document).delegate("." + windowClass, 'touchmove', false);
            }

            $.mobile.loading("show", {
                text: text,
                textVisible: !!text
            });
        }
    }

    function hideModal(){
        if (overlayDelayId) {
            clearTimeout(overlayDelayId);
            overlayDelayId = null;
        }

        hideOverlay();
        hideInitialLoad();
    }

    function hideOverlay(){
        $("." + windowClass).remove();

        // Shouldn't need to be defensive like this, but it seems that sometimes jQuery mobile
        // hasn't initialised the loader widget when the mobileinit event is fired.
        if ($.mobile && $.mobile.loading) {
            $.mobile.loading("hide");
        }
    }

    function hideInitialLoad(){
        $("body").removeClass("initial-load");
        $(".initial-load").remove();
        $('#initial-header').remove();
    }

    return {
        show: showModal,
        hide: hideModal
    };
});
